module.exports = __webpack_public_path__ + "543478771c615726716cbf297e878a42.png";